import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../../graphql";
import PropTypes from "prop-types";
import { Typography, Row, Col, Form, Input,  DatePicker } from "antd";
import FromInput from "../../../../../../components/user/from/Input";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import moment from "moment";
const { Text, Title } = Typography;
class WelfareListPaymentVictimInDocDetail extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
  };

  dateFormatNumber = (values) => {
    const { form } = this.props;

    console.log("valueReturn values", values);
    let valueReturn = changeFormatdate(moment(form.getFieldValue(values)));
    console.log("valueReturn", valueReturn);

    return valueReturn;
  };

  async componentDidMount() {}

  render() {
    const { match, rawData, isViewOnly } = this.props;
    const { loadingFullpage } = this.state;
    const { getFieldDecorator } = this.props.form;

    console.log("rawData Indoc", rawData);

    return (
      <>
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          className="py-2 mb-0"
        >
          <Col md={24} className="mb-3">
            <Text className="color-red" style={{ fontSize: "18px" }}>ข้อมูลเอกสาร</Text>
          </Col>

          <Col md={12} className="mb-2">
            <Form.Item label={"เลขที่สารบรรณ"} className="mb-0">
              {this.props.form.getFieldDecorator("refDocument", {
                initialValue: rawData?.refDocument ? rawData?.refDocument : "-",
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ เลขที่สารบรรณ",
                  },
                ],
              })(
                <Input
                  className="w-100"
                  placeholder="ระบุ เลขที่สารบรรณ"
                  disabled={isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.documentNo ? rawData?.documentNo : "-"}
              required={true}
              name={"documentNo"}
              label="เลขที่เอกสาร"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.createdByName ? rawData?.createdByName : "-"}
              required={true}
              name={"createdByName"}
              label="ผู้สร้างเอกสาร"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={
                rawData?.createdAt ? changeFormatdate(rawData?.createdAt) : "-"
              }
              required={true}
              name={"createdAt"}
              label="วันที่สร้างเอกสาร"
              mode={"text"}
            />
          </Col>

        

          {/* <Col md={12} className="mb-2">
          <Form.Item label={"วันที่อนุมัติเอกสาร"} className="mb-0">
                {this.props.form.getFieldDecorator("approveDate", {
                  initialValue:  rawData?.approveDate
                  ? moment(rawData?.approveDate)
                  : null,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ วันที่อนุมัติเอกสาร",
                    },
                  ],
                })(
                  <DatePicker
                disabled={true}
                format={this.dateFormatNumber(
                  `approveDate`
                )}
                className="w-100"
                placeholder="เลือกวันที่"
                allowClear={false}
              />
                )}
              </Form.Item>
          </Col>

          <Col md={12} className="mb-2">
          <Form.Item label={"วันที่จ่ายเงิน"} className="mb-0">
                {this.props.form.getFieldDecorator("payCashDate", {
                  initialValue:  rawData?.payCashDate
                  ? moment(rawData?.payCashDate)
                  : null,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ วันที่จ่ายเงิน",
                    },
                  ],
                })(
                  <DatePicker
                disabled={true}
                format={this.dateFormatNumber(
                  `payCashDate`
                )}
                className="w-100"
                placeholder="เลือกวันที่"
                allowClear={false}
              />
                )}
              </Form.Item>
          </Col> */}

<Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.approveDate ? changeFormatdate(rawData?.approveDate) : "-"}
              required={true}
              name={"approveDate"}
              label="วันที่อนุมัติเอกสาร"
              mode={"text"}
            />
          </Col>
          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.payCashDate ? changeFormatdate(rawData?.payCashDate) : "-"}
              required={true}
              name={"payCashDate"}
              label="วันที่จ่ายเงิน"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={
                rawData?.approveStatusName ? rawData?.approveStatusName : "-"
              }
              required={true}
              name={"approveStatusName"}
              label="สถานะเอกสาร"
              mode={"text"}
            />
          </Col>

        </Row>
      </>
    );
  }
}

WelfareListPaymentVictimInDocDetail.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimInDocDetail.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimInDocDetail = Form.create()(
  WelfareListPaymentVictimInDocDetail
);

export default withApollo(WrappedWelfareListPaymentVictimInDocDetail);
